// /**
//  * @desc render Markdown Language for React
//  */

// import * as fs from 'fs';
import React, {
  forwardRef,
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react';
// const { ipcRenderer } = require('electron');
import InfiniteScroll from 'react-infinite-scroll-component';
import Api from '../../../api';
import Avatar from '../../../components/Avatar';
import DateComponent from '../../../components/DateComponent';
import Loader from '../../../components/Loader';
import SHARED from '../../../constants';
import { AdminContext } from '../../../context/AdminContext';
import AppIcons from '../../../icons';
import RepliedMessage from '../RepliedMessage';
import blanckUser from '../../../../../assets/imgs/blank-profile-picture.png';
import zip from '../../../../../assets/imgs/fileTypes/zip.png';
import rar from '../../../../../assets/imgs/fileTypes/rar.png';
import doc from '../../../../../assets/imgs/fileTypes/doc.png';
import pdf from '../../../../../assets/imgs/fileTypes/pdf.png';
import mp3 from '../../../../../assets/imgs/fileTypes/mp3.png';
import styles from '../styles.module.scss';
import FileTypesContainer from '../../../components/FileTypesContainer';
import ChooseBackground from '../../../functions/chooseBackground';
import MessageTypes from '../../../components/ActiveChatInfo/MessageTypes';
import ChatFooter from '../ChatFooter';
import CenterModal from '../../../components/CenterModal';
import SelectedMessage from '../../../components/SelectedMessage';
import SelectedNavbar from '../../../components/SelectedNavbar';
import findDownloadPath from '../../../functions/findDownlodPath';
import MessageDateSeen from '../../../components/MessageDateSeeen';
import BrowserDetection from '../../../functions/BrowserDetection';
import isMobileTablet from '../../../functions/IsMobileTablet';
import AppEmojiIcons from '../../../icons/emojiIcons';
// import TerminalComponent from 'renderer/components/TerminalComponent';
// import { ipcRenderer } from 'electron';

// import * as fs from 'fs';
// const { dialog } = require('electron').remote;
// const fs = require('electron').remote.require('fs');
// import SHARED from '../../../../constants';
// import { AdminContext } from '../../../../context/AdminContext';
// import AppImage from '../../AppImage';
// import Avatar from '../../Avatar';
// import DateComponent from '../../DateComponent';
// import Loader from '../../Loader';
// import SHARED from '../../../../constants';
// import Button from '../../Button';
// import { useNavigate } from 'react-router-dom';

const ChatBody = forwardRef((props, ref) => {
  const {
    themeColor,
    userChannelId,
    activeMessage,
    setActiveMessage,
    // activeUser,
    setUserChannelId,
    content,
    setSharedUser,
    setActiveAudio,
    bg,
    backScale,
    showFirstMessage,
    setShowFirstMessage,
    privateUsers,
    setShowSearch,
    setActiveUser,
    setPrivateUsers,
    downloadedFiles,
    setDownloadedFiles,

    setSeekValue,
    setPlaying,
    setForwardMessages,
    themeMode,
    showSearch,
    showUserInfo,
    setShowUserInfo,
  } = useContext(AdminContext);
  console.log('showFirstMessage', showFirstMessage);
  const [hasMore, setHasMore] = useState(true);
  const [scrollNow, setScrollNow] = useState('');
  const [activePlayer, setActivePlayer] = useState();
  const [showSelectBox, setShowSelectBox] = useState();
  const [selectedMessage, setSelectedMessage] = useState([]);
  const [selectedBoxPosition, setSelectedBoxPosition] = useState();
  // const [activeMessage, setActiveMessage] = useState('');
  // const [previousChannelId, setPreviousChannelId] = useState('');
  // const [message, setMessage] = useState('');
  // const [dragActive, setDragActive] = useState(false);
  const downloadFunction = (urlis, fileName, fileType) => {
    // setLoading(true);
    let ddd = window.electron.ipcRenderer.sendMessage('download-file', {
      url: urlis,
      fileName: fileName,
      fileType: fileType,
      // filePath: '/desktop/file',
    });

    window.electron.ipcRenderer.once('files', (event) => {
      setDownloadedFiles(event);
      // setSelectedMessage([]);
      // setShowSelectBox();

      // setLoading(false);
    });
  };
  const showLocationFunction = (urlis, fileName, fileType) => {
    let ddd = window.electron.ipcRenderer.sendMessage('fileLocation', {
      url: urlis,
      fileName: fileName,
      fileType: fileType,
      // filePath: '/desktop/file',
    });

    // window.electron.ipcRenderer.once('showLocation', (event) => {
    //   setDownloadedFiles(event);
    //   setLoading(false);
    // });
  };

  const favFunction=(x)=>{
    console.log("ccccc", x)
    Api.favMessage(x.id, {roomId:x?.roomId ? x?.roomId : x?.room?.id})
    .then((res)=>{
      let array=[...props?.messages]
      if (array[array.findIndex(m=>m?.id==x?.id)]?.chatPin?.length != 0 && array[array.findIndex(m=>m?.id==x?.id)]?.chatPin){
        array[array.findIndex(m=>m?.id==x?.id)].chatPin=[]
      }else{
        array[array.findIndex(m=>m?.id==x?.id)].chatPin=[{}]
      }
      props?.setMessages(array)
    })
    .catch((err)=>{})
  }
  console.log('item', props?.item);
  const startChatFunction = (y) => {
    console.log('sssss', privateUsers, y.uuid);
    let index = privateUsers.findIndex(
      (x) => x?.users?.[0]?.channelUser?.uuid == y.uuid
    );
    if (index == -1) {
      // if (activeUser?.users?.[0]?.channelUser?.channelId != userChannelId) {
      //   Api.privateChatUsersChat()
      //   .then((res) => {
      //     setActiveUser(
      //       data?.response?.filter(
      //         (x) => x?.users?.[0]?.channelUser?.channelId == userChannelId
      //       )?.[0]
      //     );
      //     // setPrivateUsers(res?.data?.response);
      //     // setloadingUsers(false);
      //     // setUserChannelId(
      //     //   res?.data?.response?.[0]?.users?.[0]?.channelUser?.channelId
      //     // );
      //     // setActiveUser(res?.data?.response?.[0]);
      //   })
      //   .catch((err) => {});

      // }
      // setShowSearch(true);

      setShowFirstMessage(true);
      props?.setPreviousChannelId(userChannelId);
      // props?.setActiveUser(y);
      setUserChannelId(y?.uuid);
      // props?.getUserFunction();
      const newuser = {
        ...y,
        block: 0,
        users: [
          {
            unSeen: 0,
            block: 0,
            channelUser: {
              // channelId: sharedUser?.id,
              channelName: y?.name,
              uuid: y?.uuid,
            },
          },
        ],
      };
      // props?.setActiveUser(newuser);
      // setPrivateUsers([...privateUsers, newuser]);
    } else {
      setUserChannelId(y?.uuid);
      // setShowSearch(false);
    }
  };
  const scrollRef = useRef(null);
  useEffect(() => {
    if (
      userChannelId?.length != 0 &&
      props?.activeUser?.id &&
      showFirstMessage?.length == 0
    ) {
      console.log('props?.activeUser', props?.activeUser);
      props?.changeMessageFunction(props?.activeUser?.id, ref);
    }
    console.log('geolocation', navigator);
  }, [ref, props?.messages, props?.activeUser, showFirstMessage]);
  const deleteMessage = (id) => {
    // if (socket) {
    if (id == activeMessage) {
      setActiveMessage('');
      setActiveAudio();
    }
    if (props?.chatTypePrivate) {
      ref?.current?.emit('private:messageDelete', {
        messageId: id,
        uuid: userChannelId,
        typeId: props?.activeUser?.typeId,
        roomId: props?.activeUser?.id,
      });
    } else {
      ref?.current?.emit('multiple:messageDelete', {
        messageId: id,
      });
    }
  };
  const getMorePosts = () => {
    {
      props?.chatTypePrivate
        ? Api.userMessageList(
            userChannelId,
            {
              params: {
                start: props?.messages.length,
                limit: 10,
                inverse: true,
                typeId: props?.activeUser?.typeId,
              },
            }
            // , { params: { channelId: userChannelId } }
          )
            .then((res) => {
              // setMessages(messages.concat(res?.data?.response));
              const newarray = props?.messages.concat(res?.data?.response);
              props?.setMessages(newarray);
              props?.setLoadingOldMessages(false);
              props?.setCount(res?.data?.response_details.count);
            })
            .catch((err) => {
              props?.setServerError(err?.response?.data?.message);
            })
        : Api.videoMessageList(
            props?.uuid,
            {
              params: {
                start: props?.messages.length,
                limit: 10,
                inverse: true,
              },
            }
            // , { params: { channelId: userChannelId } }
          )
            .then((res) => {
              // setMessages(messages.concat(res?.data?.response));
              const newarray = props?.messages.concat(res?.data?.response);
              props?.setMessages(newarray);
              props?.setLoadingOldMessages(false);
              props?.setCount(res?.data?.response_details.count);
            })
            .catch((err) => {
              props?.setServerError(err?.response?.data?.message);
            });
    }
  };

  useEffect(() => {
    // setActiveMessage('');
    // setActiveAudio();
    setSelectedMessage([]);
  }, [props?.activeUser]);
  useEffect(() => {
    setHasMore(props?.messages.length < props?.count);

    if (props?.messages.length == 0) {
      setHasMore(false);
    }
  }, [props?.messages, props?.count]);

  const replyFunction = (item) => {
    props?.setReplyValue(item);
  };
  const ForwardFunction = (array) => {
    setForwardMessages(array);
  };

  const scrollToId = (message) => {
    const element = document.getElementById(message?.replyId);
    if (element) {
      document?.getElementById(message?.replyId)?.scrollIntoView({
        // block: 'end',
        behavior: 'smooth',
      });
    } else {
      {
        props?.chatTypePrivate
          ? Api.userMessageList(userChannelId, {
              params: {
                toId: message?.replyId,
                inverse: true,
                typeId: props?.activeUser?.typeId,
              },
            })
              .then((res) => {
                const newarray = res?.data?.response;
                props?.setMessages(newarray);
                props?.setLoadingOldMessages(false);
                setScrollNow(`${message?.replyId}`);
              })
              .catch((err) => {
                props?.setServerError(err?.response?.data?.message);
              })
          : Api.videoMessageList(props?.uuid, {
              params: {
                toId: message?.replyId,
                inverse: true,
              },
            })
              .then((res) => {
                const newarray = res?.data?.response;
                props?.setMessages(newarray);
                props?.setLoadingOldMessages(false);
                setScrollNow(`${message?.replyId}`);
              })
              .catch((err) => {
                props?.setServerError(err?.response?.data?.message);
              });
      }
    }
  };
  const activePlayerFunction = (playerId) => {
    // alert('hi');
    console.log('playerId', playerId, activePlayer);
    if (activePlayer) {
      activePlayer.pause(); // Pause previous active player
    }

    setActivePlayer(playerId);
    // activePlayer = playerId;
    // playerId.play();
  };
  useEffect(() => {
    console.log('activePlayer', activePlayer);
    if (activePlayer) {
      activePlayer.play();
    }
  }, [activePlayer]);
  // const downloadFunction = (urlis, fileName, fileType) => {
  //   let ddd = window.electron.ipcRenderer.sendMessage('download-file', {
  //     url: urlis,
  //     fileName: fileName,
  //     fileType: fileType,
  //     // filePath: '/desktop/file',
  //   });
  //   console.log('fffffffff', ddd);
  //   setUpdate(!update);
  // };
  useEffect(() => {
    let element = document?.getElementById(scrollNow);
    // if (scrollNow?.length != 0 && element) {
    if (scrollNow?.length != 0) {
      console.log('sc', scrollNow);
      document?.getElementById(scrollNow)?.scrollIntoView({
        behavior: 'smooth',
      });
      setScrollNow('');
    }
  }, [scrollNow]);

  const switchToShare = (user) => {
    // setActiveMessage('');
    // setSeekValue(0);
    // setPlaying(false);
    // setActiveAudio();
    console.log('userrrrrrr', user, userChannelId);
    // ref.current.emit(
    //   'private:disconnect',
    //   {
    //     uuid: userChannelId,
    //     typeId: props?.activeUser?.typeId,
    //     roomId: props?.activeUser?.id,
    //   },
    //   (message) => {}
    // );
    if (userChannelId != user?.uuid) {
      // alert('1');
      // props?.setMessages([]);
      // setActiveMessage('');
      // setActiveAudio();
      setActiveUser();
      props?.setSharedUserClicked(user?.name);
      startChatFunction(user);
      // setUserChannelId(user?.uuid);
      // props?.setActiveUser(user);
      setSharedUser(user);
      // setPrivateUser;
    }
    props?.setReplyValue({ id: '' });
  };
  function isJSON(str) {
    try {
      return JSON.parse(str) && !!str;
    } catch (e) {
      return false;
    }
  }
  const scrollFunction = () => {
    // const div = document.querySelector('.message__chats');
    // const observer = new IntersectionObserver((entries) => {
    //   if (entries[0].isIntersecting) {
    //     // div is visible
    //   }
    // });
    // observer.observe(div);
    // var scrollTop =
    //   document.documentElement.scrollTop || document.body.scrollTop;
    // var scrollLeft =
    //   document.documentElement.scrollLeft || document.body.scrollLeft;
    // // Get the element under the scrollbar
    // var elementUnderScrollbar = document.elementFromPoint(
    //   scrollLeft,
    //   scrollTop + window.innerHeight - 1
    // );
    // // Get the div container element
    // var divContainer = document.getElementById('messageContainer');
    // // Get the current scroll position of the div container
    // var scrollTop = divContainer.scrollTop;
    // var scrollLeft = divContainer.scrollLeft;
    // var elementUnderScrollbar = document.elementFromPoint(
    //   divContainer.offsetLeft + divContainer.offsetWidth - 1,
    //   divContainer.offsetTop + divContainer.offsetHeight - 1
    // );
    // console.log(
    //   'divcontainer',
    //   divContainer,
    //   scrollTop,
    //   scrollLeft,
    //   elementUnderScrollbar
    // );
    // // Get the element under the scrollbar
    // // var elementUnderScrollbar = divContainer.elementFromPoint(
    // //   scrollLeft + divContainer.offsetWidth - 1,
    // //   scrollTop + divContainer.offsetHeight - 1
    // // );
    // // // Check if the element is a div
    // let myDiv = document.getElementsByClassName('message__chats');
    // // console.log('elementUnderScrollbar', elementUnderScrollbar);
    // // if (elementUnderScrollbar.tagName.toLowerCase() === 'div') {
    // if (elementUnderScrollbar.classList.contains('message__chats')) {
    //   // Do something with the div element
    //   console.log(
    //     'The div element under the scrollbar is:',
    //     elementUnderScrollbar
    //   );
    // }
  };
  console.log(
    'dddd',
    props?.direction == 'rtl',
    'rotate-180',
    props?.channelId
  );
  const onScrollDiv = () => {
    let cond1 = scrollRef.current.scrollHeight - scrollRef.current.clientHeight;
    let cond2 = scrollRef.current.scrollTop + 1;
    let isScrolledToBottom = cond1 < cond2 ? true : false;
    if (!isScrolledToBottom) {
      // alert('1');
    }
  };

  const onContextMenuContact = (message, extraHeight = 0, e) => {
    e.preventDefault();
    if (selectedMessage?.length == 0) {
      let sidebarWidth = document.getElementById('sidebar').offsetWidth;
      console.log('sidebarwidth', sidebarWidth);
      // if (
      //   e.type == 'touchstart' ||
      //   e.type == 'touchmove' ||
      //   e.type == 'touchend' ||
      //   e.type == 'touchcancel'
      // ) {
      //   var touch =
      //     e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
      //   x =
      //     props?.direction == 'rtl' ? touch.pageX : touch.pageX - sidebarWidth;
      //   y =
      //     touch.pageY -
      //     document.getElementById(message?.id).getBoundingClientRect().top;
      // } else {
      setSelectedBoxPosition({
        // x: e.pageX,
        x: props?.direction == 'rtl' ? e.pageX : e.pageX - sidebarWidth,
        y:
          e.pageY -
          // 60 -
          extraHeight -
          document.getElementById(message?.id).getBoundingClientRect().top,
      });
      // }
      setShowSelectBox(message?.id);
    }
  };
  const onContextMenuMe = (message, extraHeight = 0, e) => {
    e.preventDefault();
    if (selectedMessage?.length == 0) {
      let sidebarWidth = document.getElementById('sidebar').offsetWidth;
      console.log('sidebarwidth', sidebarWidth);
      // if (
      //   extraHeight == true
      //   // e.type == 'touchstart' ||
      //   // e.type == 'touchmove' ||
      //   // e.type == 'touchend' ||
      //   // e.type == 'touchcancel'
      // ) {
      //   // alert('1');
      //   var touch =
      //     e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
      //   x =
      //     props?.direction == 'rtl' ? touch.pageX : touch.pageX - sidebarWidth;
      //   y =
      //     touch.pageY -
      //     document.getElementById(message?.id).getBoundingClientRect().top;
      // } else {
      // alert(extraHeight);
      setSelectedBoxPosition({
        x: props?.direction == 'rtl' ? e.pageX : e.pageX - sidebarWidth,
        y:
          e.pageY -
          // 60 -
          extraHeight -
          document.getElementById(message?.id).getBoundingClientRect().top,
      });
      // }
      setShowSelectBox(message?.id);
    }
  };
  // useEffect(() => {}, [showFirstMessage]);
  // ${
  //   ChooseBackground(bg)?.repeat ? 'repeatBg' : 'noRepeatBg'
  // }
  console.log(
    'showSelectBox',
    showSelectBox,
    selectedMessage,
    props?.replyValue
  );
  console.log('showuserinfo', showUserInfo, selectedBoxPosition);
  var timer;
  var touchduration = 1000; //length of time we want the user to touch before we do something
  let touchStartTimeStamp;
  let touchEndTimeStamp;

  const showUserInfoFunction = (uuid) => {
    Api.userList({ params: { uuid: uuid } })
      .then((res) => {
        setShowUserInfo(...res.data.response);
      })
      .catch((err) => {});
  };

  const copyFunction = (e, message, typeId) => {
    e.preventDefault();

    if (typeId == 1) {
      navigator.clipboard.writeText(`${message}`);
    }
    if (typeId == 4) {
      navigator.clipboard.writeText(
        `${SHARED?.copy_URL}/video/play/${JSON.parse(message)?.uuid}`
      );
    }

    // setTimeout(function () {
    //   setShowTooltip1(false);
    // }, 1000);
  };
  const clickFavFunction=(item)=>{
    favFunction(item);
    setSelectedMessage([]);
    setShowSelectBox();
  }
  console.log('showuserinfo', showUserInfo, selectedMessage);
  return (
    <>
    {/* <TerminalComponent ref={ref}/> */}
      {props?.loadingOldMessages ? (
        <Loader
          // className={styles.lds_ring}
          width="relative w-[100%]"
          // height='h-[65%]'
          height="onlineLoader"
        />
      ) : (
        <>
          <form
            onDragEnter={props?.handleDrag}
            onDragLeave={props?.handleDrag}
            onDragOver={(e) => e.preventDefault()}
            onDrop={props?.handleDrop}
          >
            <>
              <div
                className={`infinitContainer relative `}
                // style={{
                //   backgroundImage: `url(${ChooseBackground(bg)?.src})`,
                //   // backgroundSize: '200px',
                //   // backgroundSize: `${SHARED.maxBgScale * backScale}px`,
                //   backgroundSize: ChooseBackground(bg)?.cover
                //     ? 'cover'
                //     : `${SHARED.maxBgScale * backScale}px`,
                // }}
                // onDragEnter={props?.handleDrag}
                // onDragLeave={props?.handleDrag}
                // onDragOver={props?.handleDrag}
                // onDrop={props?.handleDrop}
              >
                <div
                  className={`message__container relative rtl ${
                    themeMode != 'dark'
                      ? 'message__containerScrollbarW'
                      : 'message__containerScrollbarD'
                  } ${
                    props?.replyValue?.id?.length != 0 && 'extraChatPadding'
                  } `}
                  id="messageContainer"
                  style={{
                    // height: 300,
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column-reverse',
                    // backgroundImage: `url(${ChooseBackground(bg)?.src})`,
                  }}
                  onScroll={() => {
                    scrollFunction();
                  }}
                >
                  {/*Put the scroll bar always on the bottom*/}
                  <InfiniteScroll
                    dataLength={props?.messages?.length}
                    next={getMorePosts}
                    style={{
                      display: 'flex',
                      flexDirection: 'column-reverse',
                      paddingBottom: '43px',
                      // backgroundImage: `url(${ChooseBackground(bg)?.src})`,
                      // backgroundImage: `url(${ChooseBackground(bg)?.src})`,
                      // backgroundSize: '200px',
                      // padding: '10px',
                    }} //To put endMessage and loader to the top.
                    inverse={true} //
                    hasMore={hasMore}
                    loader={
                      <Loader
                        id="first"
                        width={'w-[100%]'}
                        height={'h-[100px]'}
                      />
                    }
                    scrollableTarget="messageContainer"
                    ref={scrollRef}
                    // onScroll={onScrollDiv}
                  >
                    {props?.messages?.map((message, index) => (
                      <>
                        {message?.typeId != 5 &&
                        message?.typeId != 6 &&
                        message?.typeId != 7 ? (
                          <>
                            {message?.roomUser?.channelUser?.uuid ==
                            props?.channelId ? (
                              <div
                                className={` message__chats messageContainerInsidePadding relative ${
                                  isMobileTablet() == true && 'noUserSelect'
                                } ${
                                  selectedMessage?.findIndex(
                                    (x) => x.id == message?.id
                                  ) != -1 && 'selectedMessageContainer'
                                } ${
                                  props?.replyValue?.id == message?.id &&
                                  'mainBg'
                                } `}
                                key={index}
                                id={message?.id}
                                onContextMenu={(e) => {
                                  // if (e.type == 'touch') {
                                  //   alert('touch');
                                  // }
                                  // console.log('hhhh', isMobileTablet());
                                  if (isMobileTablet() == true) {
                                    if (BrowserDetection() != 'Safari') {
                                      onContextMenuMe(message, 60, e);
                                    }
                                  } else {
                                    // alert('2');

                                    onContextMenuMe(message, 0, e);
                                  }
                                  // console.log('eis====', e.eventPhase);
                                  // alert('eis====', e.eventPhase);

                                  // if (
                                  //   // e.type == 'touchstart' ||
                                  //   // e.type == 'touchmove' ||
                                  //   // e.type == 'touchend' ||
                                  //   // e.type == 'touchcancel'
                                  //   node.ontouchstart = absorbEvent_;
                                  //   node.ontouchmove = absorbEvent_;
                                  //   node.ontouchend = absorbEvent_;
                                  //   node.ontouchcancel = absorbEvent_;
                                  // ) {
                                  //   alert('hhh');
                                  // } else {

                                  // onContextMenuMe(message, 0, e);
                                  // }
                                }}
                                onTouchStart={(e) => {
                                  // let ee = e;
                                  // e.preventDefault();
                                  // timer = setTimeout(
                                  //   onContextMenuMe(message, 260, ee),
                                  //   touchduration
                                  // );
                                  if (
                                    BrowserDetection() == 'Safari' &&
                                    isMobileTablet() == true
                                  ) {
                                    touchStartTimeStamp = e.timeStamp;
                                  }
                                }}
                                onTouchEnd={(e) => {
                                  if (
                                    BrowserDetection() == 'Safari' &&
                                    isMobileTablet() == true
                                  ) {
                                    touchEndTimeStamp = e.timeStamp;

                                    let time =
                                      touchEndTimeStamp - touchStartTimeStamp; // in miliseconds
                                    if (time == 500) {
                                      onContextMenuMe(message, 60, e);
                                    }
                                  }
                                  // if (timer) {
                                  //   clearTimeout(timer);
                                  // }
                                }}
                                onClick={(e) => {
                                  if (selectedMessage?.length != 0) {
                                    let index = selectedMessage?.findIndex(
                                      (x) => x.id == message?.id
                                    );
                                    if (index == -1) {
                                      setSelectedMessage([
                                        ...selectedMessage,
                                        message,
                                      ]);
                                    } else {
                                      setSelectedMessage([
                                        ...selectedMessage.filter(
                                          (x) => x.id != message?.id
                                        ),
                                      ]);
                                    }
                                  } else {
                                    e.preventDefault();
                                    e.stopPropagation();
                                  }
                                }}
                              >
                                <div
                                  className={`message__sender ${
                                    message?.file?.fileExtension?.type ==
                                      'image' ||
                                    message?.file?.fileExtension?.type ==
                                      'video'
                                      ? 'message_sentImage'
                                      : 'message_sent'
                                  }`}
                                >

                                  <div
                                    className={`flex flex-col justify-start items-start w-auto ml-auto `}
                                  >
                                    {/* <div
                                      className={`flex flex-row justify-between items-center w-full h-auto`}
                                    >
                                      <p className="sender__name mr-[5px]">
                                        {props?.content?.chatPage?.you}
                                      </p>
                                      <div
                                        onClick={() => {
                                          deleteMessage(message?.id);
                                        }}
                                        className={`mr-auto cursor-pointer`}
                                      >
                                        <AppIcons.closeIcon
                                          width={12}
                                          height={12}
                                        />
                                      </div>
                                    </div> */}
                                    {message?.reply && (
                                      <RepliedMessage
                                        message={message}
                                        scrollToId={scrollToId}
                                        isJSON={isJSON}
                                      />
                                    )}
                                    {message?.message != null ? (
                                      <>

                                      <MessageTypes
                                        message={message}
                                        switchToShare={switchToShare}
                                        content={props?.content}
                                      />
                                      </>
                                    ) : (
                                      <FileTypesContainer
                                        item={message}
                                        extraStyle={styles.extraFileStyle}
                                        chatBody={true}
                                        activePlayer={setActivePlayer}
                                        activePlayerFunction={
                                          activePlayerFunction
                                        }
                                        activeMessage={activeMessage}
                                        setActiveMessage={setActiveMessage}
                                        messages={props?.messages}
                                        showSeen={true}
                                      />
                                    )}
                                    {/* {message?.file?.fileExtension?.type !=
                                      'image' && ( */}
                                    <MessageDateSeen item={message} />
                                    {/* )} */}
                                    {message?.chatPin?.length != 0 && message?.chatPin != undefined &&

<div className={`absolute starMessageSender`}>
<AppEmojiIcons.StarFullIcon  width={"18px"} height={'18px'} fill={`#ffb700`}  className={`noFilterSvg`}/>
</div>
}
                                  </div>
                                </div>
                                {showSelectBox == message?.id && (
                                  <SelectedMessage
                                    showSelectBox={showSelectBox}
                                    setShowSelectBox={setShowSelectBox}
                                    selectedMessage={selectedMessage}
                                    setSelectedMessage={setSelectedMessage}
                                    selectedBoxPosition={selectedBoxPosition}
                                    onClickSelect={() => {
                                      setSelectedMessage([
                                        ...selectedMessage,
                                        message,
                                      ]);
                                      setShowSelectBox();
                                    }}
                                  />
                                )}
                                {/* <div
                        className={`date flex flex-row justify-start items-center h-auto w-auto my-[5px] ${
                          themeColor != 'white' && 'textWhite'
                        }`}
                      >
                        <DateComponent createdAt={message?.createdAt} />
                      </div> */}
                              </div>
                            ) : (
                              <div
                                // className="message__chats messageContainerInsidePadding flex-row-reverse"
                                className={` message__chats messageContainerInsidePadding flex-row-reverse relative ${
                                  selectedMessage?.findIndex(
                                    (x) => x.id == message?.id
                                  ) != -1 && 'selectedMessageContainer'
                                } ${
                                  isMobileTablet() == true && 'noUserSelect'
                                }`}
                                key={index}
                                id={message?.id}
                                onContextMenu={(e) => {
                                  if (isMobileTablet() == true) {
                                    if (BrowserDetection() != 'Safari') {
                                      onContextMenuContact(message, 60, e);
                                    }
                                    // alert('1');
                                  } else {
                                    onContextMenuContact(message, 0, e);
                                  }
                                }}
                                onTouchStart={(e) => {
                                  // let ee = e;
                                  // e.preventDefault();
                                  // timer = setTimeout(
                                  //   onContextMenuContact(message, 260, ee),
                                  //   touchduration
                                  // );
                                  if (
                                    BrowserDetection() == 'Safari' &&
                                    isMobileTablet() == true
                                  ) {
                                    touchStartTimeStamp = e.timeStamp;
                                  }
                                }}
                                onTouchEnd={(e) => {
                                  if (
                                    BrowserDetection() == 'Safari' &&
                                    isMobileTablet() == true
                                  ) {
                                    touchEndTimeStamp = e.timeStamp;

                                    let time =
                                      touchEndTimeStamp - touchStartTimeStamp; // in miliseconds
                                    if (time == 500) {
                                      onContextMenuContact(message, true, e);
                                    }
                                  }
                                  // if (timer) {
                                  //   clearTimeout(timer);
                                  // }
                                }}
                                onClick={(e) => {
                                  if (selectedMessage?.length != 0) {
                                    let index = selectedMessage?.findIndex(
                                      (x) => x.id == message?.id
                                    );
                                    if (index == -1) {
                                      setSelectedMessage([
                                        ...selectedMessage,
                                        message,
                                      ]);
                                    } else {
                                      setSelectedMessage([
                                        ...selectedMessage.filter(
                                          (x) => x.id != message?.id
                                        ),
                                      ]);
                                    }
                                  } else {
                                    e.stopPropagation();
                                  }
                                }}
                              >
                                <div
                                  className={`flex flex-row-reverse justify-start items-center h-auto w-auto my-[5px]`}
                                >
                                  {props?.messages?.[index - 1]?.roomUserId !=
                                  message?.roomUserId ? (
                                    <Avatar
                                      width={37}
                                      height={37}
                                      containerclassName={`cursor-pointer`}
                                      className={`cursor-pointer roundBox`}
                                      src={
                                        message?.roomUser?.channelUser?.image
                                          ?.name
                                          ? message?.roomUser?.channelUser
                                              ?.image?.name
                                          : blanckUser
                                      }
                                      local={
                                        !message?.roomUser?.channelUser?.image
                                          ?.name
                                      }
                                      onClick={() => {
                                        showUserInfoFunction(
                                          message?.roomUser?.channelUser?.uuid
                                        );
                                      }}
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        width: '37px',
                                        margin: '0 5px',
                                      }}
                                    ></div>
                                  )}
                                  {/* <p className={`text-left ml-[5px]`}>
                          {message?.roomUser?.channelUser?.channelName
                            ? message?.roomUser?.channelUser?.channelName
                            : message?.roomUser?.channelUser?.username}
                        </p> */}
                                </div>

                                <div
                                  className={`message__recipient ${
                                    message?.file?.fileExtension?.type ==
                                      'image' ||
                                    message?.file?.fileExtension?.type ==
                                      'video'
                                      ? 'message_recievedImage'
                                      : 'message_recieved'
                                  }`}
                                >

                                  {/* <p className={`text-left ml-[5px]`}>
                                    {message?.roomUser?.channelUser?.channelName
                                      ? message?.roomUser?.channelUser
                                          ?.channelName
                                      : message?.roomUser?.channelUser
                                          ?.username}
                                  </p> */}

                                  {message?.reply && (
                                    <RepliedMessage
                                      message={message}
                                      scrollToId={scrollToId}
                                      isJSON={isJSON}
                                    />
                                  )}
                                  {message?.message != null ? (
                                    <MessageTypes
                                      message={message}
                                      switchToShare={switchToShare}
                                      content={props?.content}
                                    />
                                  ) : (
                                    <FileTypesContainer
                                      item={message}
                                      extraStyle={styles.extraFileStyle}
                                      chatBody={true}
                                      activePlayer={setActivePlayer}
                                      activePlayerFunction={
                                        activePlayerFunction
                                      }
                                      setActiveMessage={setActiveMessage}
                                      activeMessage={activeMessage}
                                      messages={props?.messages}
                                      showSeen={false}
                                    />
                                  )}
                                  {/* <div
                                    className={`flex flex-row-reverse justify-between items-center mt-10px  w-full `}
                                  >
                                    <div
                                      className={`date flex flex-row-reverse justify-start items-center h-auto w-full my-[5px] `}
                                    >
                                      <DateComponent
                                        createdAt={message?.createdAt}
                                        className={`preserveWhiteThemeColor`}
                                      />
                                    </div>
                                  </div> */}
                                  {/* {message?.file?.fileExtension?.type !=
                                    'image' && ( */}
                                  <MessageDateSeen
                                    item={message}
                                    showSeen={false}
                                  />
                                                                                                                                                          {message?.chatPin?.length != 0 && message?.chatPin != undefined &&

<div className={`absolute starMessage`}>
<AppEmojiIcons.StarFullIcon  width={"18px"} height={'18px'} fill={`#ffb700`}  className={`noFilterSvg`}/>
</div>
}
                                  {/* )} */}
                                </div>
                                {showSelectBox == message?.id && (
                                  <SelectedMessage
                                    showSelectBox={showSelectBox}
                                    setShowSelectBox={setShowSelectBox}
                                    selectedMessage={selectedMessage}
                                    setSelectedMessage={setSelectedMessage}
                                    selectedBoxPosition={selectedBoxPosition}
                                    onClickSelect={() => {
                                      setSelectedMessage([
                                        ...selectedMessage,
                                        message,
                                      ]);
                                      setShowSelectBox();
                                    }}
                                  />
                                )}
                                {/* <div
                        className={`date flex flex-row-reverse justify-start items-center h-auto w-auto my-[5px] ${
                          themeColor != 'white' && 'textWhite'
                        }`}
                      >
                        <DateComponent createdAt={message?.createdAt} />
                      </div> */}
                              </div>
                            )}
                          </>
                        ) : (
                          <MessageTypes
                            message={message}
                            switchToShare={switchToShare}
                            content={props?.content}
                          />
                        )}
                      </>
                    ))}
                  </InfiniteScroll>
                </div>
                {/* <div id='first'></div> */}
                {/* {props?.dragActive && (
              <div
                className={`dragFileElement`}
                onDragEnter={props?.handleDrag}
                onDragLeave={props?.handleDrag}
                onDragOver={(e) => props?.handleDrag(e)}
                onDrop={(e) => props?.handleDrop(e)}
              ></div>
            )} */}
                {/* <input type="file" className={`hiddenInput`} /> */}
              </div>
              {/* {props?.replyValue?.id?.length != 0 && (
              <div
                className={`replyBox grayShadow ${
                  themeColor == 'white' ? 'light' : 'modalHeaderBg text-white'
                }`}
              >


                <AppIcons.replyForwardIcon
                  width={20}
                  height={20}
                  className={props?.direction == 'rtl' ? 'rotate-180' : ''}
                />

                <div
                  className={`flex flex-col justify-start items-start items-start 
                  ${
                    props?.direction == 'rtl'
                      ? 'text-right ml-auto'
                      : 'text-left ml-auto'
                  }`}
                >
                  <p>{content.replyToMessage}</p>
                  {props?.replyValue?.message ? (
                    <p>
                      {props?.replyValue?.typeId == 3
                        ? JSON.parse(props?.replyValue?.message)?.name
                        : props?.replyValue?.message}
                    </p>
                  ) : (
                    <>
                      {props?.replyValue?.file?.fileExtension?.type ==
                        'image' && (
                        <>
                          <img
                            className={`replyFile`}
                            src={`${SHARED?.socketServerImage}${props?.replyValue?.file?.name}`}
                          />
                          <p>{props?.replyValue?.file?.name}</p>
                        </>
                      )}

                      {props?.replyValue?.file?.fileExtension?.type ==
                        'video' && (
                        <>
                          <video
                            className={`replyFile`}
                            src={`${SHARED?.socketServerVideo}${props?.replyValue?.file?.name}`}
                            // controls
                          />
                          <p>{props?.replyValue?.file?.name}</p>
                        </>
                      )}

                      {props?.replyValue?.file?.fileExtension?.type ==
                        'music' && (
                        <>
                          <img
                            className={`replyFile`}
                            // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                            // controls
                            src={mp3}
                          />
                          <p>{props?.replyValue?.file?.name}</p>
                        </>
                      )}
                      {props?.replyValue?.file?.fileExtension?.type ==
                        'zip' && (
                        <>
                          <img
                            className={`replyFile`}
                            // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                            // controls
                            src={zip}
                          />
                          <p>{props?.replyValue?.file?.name}</p>
                        </>
                      )}
                      {props?.replyValue?.file?.fileExtension?.type ==
                        'rar' && (
                        <>
                          <img
                            className={`replyFile`}
                            // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                            // controls
                            src={rar}
                          />
                          <p>{props?.replyValue?.file?.name}</p>
                        </>
                      )}

                      {props?.replyValue?.file?.fileExtension?.type ==
                        'doc' && (
                        <>
                          <img
                            className={`replyFile`}
                            // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                            // controls
                            src={doc}
                          />
                          <p>{props?.replyValue?.file?.name}</p>
                        </>
                      )}

                      {props?.replyValue?.file?.fileExtension?.type ==
                        'pdf' && (
                        <>
                          <img
                            className={`replyFile`}
                            // href={`${SHARED?.socketServerFile}${item?.file?.name}`}
                            // controls
                            src={pdf}
                          />
                          <p>{props?.replyValue?.file?.name}</p>
                        </>
                      )}
                    </>
                  )}
                </div>
                <AppIcons.closeIcon
                  width={12}
                  height={12}
                  onClick={() => {
                    props?.setReplyValue({ id: '' });
                  }}
                />
              </div>
            )} */}

              <div className="message__status">
                <p>{props?.typingStatus}</p>
              </div>
              <div ref={props?.lastMessageRef} />
            </>
          </form>
          {selectedMessage?.length != 0 && (
            <SelectedNavbar
              selectedMessage={selectedMessage}
              setSelectedMessage={setSelectedMessage}
              setShowSelectBox={setShowSelectBox}
              downloadedFiles={downloadedFiles}
              onClickDownload={() => {
                let path = findDownloadPath(selectedMessage?.[0]);
                window.electron &&
                  downloadFunction(
                    `${path}${selectedMessage?.[0]?.file?.name}`,
                    `${selectedMessage?.[0]?.file?.name}`,
                    selectedMessage?.[0]?.file?.fileExtension?.type
                  );
              }}
              path={findDownloadPath(selectedMessage?.[0])}
              onClickLocation={() => {
                let path = findDownloadPath(selectedMessage?.[0]);
                window.electron &&
                  showLocationFunction(
                    `${path}${selectedMessage?.[0]?.file?.name}`,
                    `${selectedMessage?.[0]?.file?.name}`,
                    selectedMessage?.[0]?.file?.fileExtension?.type
                  );
              }}
              onClickReply={() => {
                replyFunction(selectedMessage?.[0]);
                setSelectedMessage([]);
                setShowSelectBox();
              }}
              onClickForward={() => {
                ForwardFunction(selectedMessage);
                setSelectedMessage([]);
                setShowSelectBox();
              }}
              onClickDelete={() => {
                let array = [];
                selectedMessage?.map((item, index) => {
                  array = [...array, item?.id];
                });
                if (props?.chatTypePrivate) {
                  ref?.current?.emit('private:messageDelete', {
                    messageId: array,
                    uuid: userChannelId,
                    typeId: props?.activeUser?.typeId,
                    roomId: props?.activeUser?.id,
                  });
                } else {
                  ref?.current?.emit('multiple:messageDelete', {
                    messageId: item?.id,
                  });
                }
              }}
              onClickCopy={(e) => {
                copyFunction(
                  e,
                  selectedMessage?.[0]?.message,
                  selectedMessage?.[0]?.typeId
                );
                setSelectedMessage([]);
                setShowSelectBox();
              }}
                
                onClickFav={()=>{clickFavFunction(selectedMessage?.[0])}}
            />
          )}
        </>
      )}
    </>
  );
});

export default ChatBody;
